import { message } from 'antd';
import { PrintableEpcProposal } from '@/components/epc/commercial-ux/PrintableEpcProposal';
import { openPmvPrintOverlay } from '@/utils/openPmvPrintOverlay';
import type { EpcProposalPrintBundle } from '@/utils/epcProposalPrint';
import { openEpcEstimatePrint } from '@/utils/openEpcEstimatePrint';

export function openEpcProposalPrint(bundle: EpcProposalPrintBundle): void {
  try {
    openPmvPrintOverlay((onClose) => <PrintableEpcProposal bundle={bundle} onClose={onClose} />);
  } catch (e: unknown) {
    const err = e as { message?: string };
    message.error(err?.message || 'Failed to open proposal print');
  }
}

export async function openLinkedEstimatePrint(opts: {
  estimateId?: string | null;
  revisionId?: string | null;
  tenderTitle?: string;
}): Promise<void> {
  if (!opts.estimateId || !opts.revisionId) {
    message.warning('Certify an Approved estimate basis before printing the estimate detail');
    return;
  }
  await openEpcEstimatePrint({
    estimateId: opts.estimateId,
    revisionId: opts.revisionId,
    tenderTitle: opts.tenderTitle,
  });
}
